import React, { useState, useEffect, useRef } from "react";
import {
  CtxWrap,
  DotsBtn,
  DropMenu,
  DropItem,
  G,
  IcoMoreVertical,
  IcoEdit,
  DropDivider,
  IcoArrowUp,
  IcoArrowDown,
  IcoTrash,
  IcoFolderPlus,
} from "./styles";

const BundleContextMenu = ({
  bundle,
  bundleIdx,
  totalBundles,
  onRename,
  onMoveUp,
  onMoveDown,
  onDelete,
  onCreateSubFolder,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const act = (fn) => {
    fn();
    setOpen(false);
  };

  return (
    <CtxWrap ref={ref}>
      <DotsBtn
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        $open={open}
      >
        <IcoMoreVertical size={14} color={G.slate500} />
      </DotsBtn>
      {open && (
        <DropMenu>
          <DropItem onClick={() => act(() => onCreateSubFolder(bundle.id))}>
            <IcoFolderPlus size={13} color={G.teal} />
            <span>Create Sub-folder</span>
          </DropItem>
          <DropDivider />
          <DropItem onClick={() => act(() => onRename(bundle.id))}>
            <IcoEdit size={12} color={G.slate500} />
            <span>Rename</span>
          </DropItem>
          <DropDivider />
          <DropItem
            $disabled={bundleIdx === 0}
            onClick={() => {
              if (bundleIdx > 0) act(() => onMoveUp(bundleIdx));
            }}
          >
            <IcoArrowUp
              size={12}
              color={bundleIdx === 0 ? G.slate300 : G.slate500}
            />
            <span>Move Up</span>
          </DropItem>
          <DropItem
            $disabled={bundleIdx === totalBundles - 1}
            onClick={() => {
              if (bundleIdx < totalBundles - 1)
                act(() => onMoveDown(bundleIdx));
            }}
          >
            <IcoArrowDown
              size={12}
              color={bundleIdx === totalBundles - 1 ? G.slate300 : G.slate500}
            />
            <span>Move Down</span>
          </DropItem>
          <DropDivider />
          <DropItem onClick={() => act(() => onDelete(bundle))} $danger>
            <IcoTrash size={12} color={G.red} />
            <span>Delete Bundle</span>
          </DropItem>
        </DropMenu>
      )}
    </CtxWrap>
  );
};

export default BundleContextMenu;
